/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum WoundPictureEditAliases {
  CONTEXTUAL_BAR_ADD_PICTURE = 'contextual-bar-add-picture',
  DATE_FIELD = 'date-field',
  FIELD_DATE = 'field-date',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PHOTO = 'field-photo',
  FIELD_TIME = 'field-time',
  FIELD_TITLE = 'field-title',
  FORM_ADD_PICTURE = 'form-add-picture',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_TITLE = 'input-title',
  PANEL_CONTENT = 'panel-content',
  PANEL_HEADER = 'panel-header',
  PHOTO_UPLOADER = 'photo-uploader',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TIME_FIELD = 'time-field',
  WOUND_PICTURE_LAYOUT = 'wound-picture-layout',
}
export { WoundPictureEditAliases };
